import api from '@mint-lib/api';

import { WithCurrenciesApiResponse } from '../../types/types.js';
import { CURRENCY } from '../endpoints.js';
import { NormalizedMainCurrencyItem } from '../getMainCurrencies/getMainCurrencies.types.js';

export const deleteMainCurrency = async (
  mainCurrencyId: string,
): Promise<WithCurrenciesApiResponse<NormalizedMainCurrencyItem[]>> => {
  return api.delete(`${CURRENCY}${mainCurrencyId}/`).then((data) => {
    return data.data;
  });
};
